import { createAction, props } from '@ngrx/store';

export const jobFormIdSelect = createAction('[Job Form] Select id', props<{ id: number }>());

export const fromCreateJob = createAction(
  '[Job Form] from create job',
  props<{ fromCreateJob: string }>(),
);
